import React from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { ECustomReportType, ICustomReportDocument } from "../../../../models"
import { FloatingActionButton, Table, TableBody, TableRow, TableRowColumn } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import { EnumValues } from "enum-values"
import * as api from "../../../../api"
import AppStateStore from "../../../../stores/AppStateStore"
import AddCustomReportDialog from "./AddCustomReportDialog"
import AuthenticationStore from "../../../../stores/AuthenticationStore"

interface IProps {

}
interface IState {
    loading: boolean
    hoverRowNumber: number
    customReports: ICustomReportDocument[]
    openAddCustomReportDialog: boolean
    editCustomReport: ICustomReportDocument
}

export default class CustomReport extends React.Component<IProps, IState> {
    private readonly
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: true,
            hoverRowNumber: -1,
            customReports: [],
            openAddCustomReportDialog: false,
            editCustomReport: null
        }
        autobind(this)
        this.readonly = !(
            permissionHelper.isGlobalAdmin() ||
            (
                AuthenticationStore.getLoggedInAccountManagerUser() ?
                    permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.AccountScheduledJob) :
                    false
            )
        )
    }

    componentDidMount() {
        this.getCustomReports()
    }

    getCustomReports() {
        api.getAccountCustomReports().then(res =>
            this.setState({
                customReports: res.data,
                loading: false
            })
        )
    }

    handleAdd(customReport: ICustomReportDocument) {
        this.setState({ openAddCustomReportDialog: false, editCustomReport: null }, () => {
            AppStateStore.setProgressSnackbarContent("loading")
            api.addCustomReport(customReport).then(() => {
                AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
                this.getCustomReports()
            })
        })
    }

    handleUpdate(customReport: ICustomReportDocument) {
        this.setState({ openAddCustomReportDialog: false, editCustomReport: null }, () => {
            AppStateStore.setProgressSnackbarContent("loading")
            api.updateCustomReport(customReport).then(() => {
                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
                this.getCustomReports()
            })
        })
    }

    handleDelete(customReport: ICustomReportDocument) {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_delete_this_custom_report,
            confirm: () => {
                AppStateStore.setProgressSnackbarContent("loading")
                api.deleteCustomReports([customReport.Id]).then(() => {
                    AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
                    this.getCustomReports()
                })
            }
        })
    }

    render() {
        if (this.state.loading) return null
        return (
            <div>
                {!this.readonly && EnumValues.getValues(ECustomReportType).length !== this.state.customReports.length &&
                    <FloatingActionButton
                        data-intercom-target={"menu-AccountSettings-CustomReports-Btn-Add"}
                        style={{ position: "absolute", marginTop: -90, right: 55, display: "inline-block", zIndex: 100 }}
                        mini
                        secondary
                        onTouchTap={() => this.setState({ openAddCustomReportDialog: true })}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                {!this.state.customReports.length ?
                    strings.There_is_no_Custom_Report :
                    <Table
                        multiSelectable={false}
                        selectable={false}
                        fixedHeader={true}
                        style={styles.tableBodyStyle}
                        onRowHover={rowNumber => this.setState({ hoverRowNumber: rowNumber })}
                    >
                        <TableBody showRowHover={!this.readonly} deselectOnClickaway={false} displayRowCheckbox={false}>
                            {this.state.customReports.map((customReport, i) =>
                                <TableRow key={`row-${i}`} style={{ heigth: 45 }}>
                                    <TableRowColumn style={styles.columnValue}>
                                        {`${strings[EnumValues.getNameFromValue(ECustomReportType, customReport.Type)]} - ${customReport.Name}`}
                                    </TableRowColumn>
                                    {!this.readonly && [
                                        <TableRowColumn key="edit" style={{ width: 10, paddingRight: 0 }} className="prevent-cell-click">
                                            {this.state.hoverRowNumber === i &&
                                                <div onClick={e => e.stopPropagation()}>
                                                    <div
                                                        data-intercom-target={i === 0 && "menu-AccountSettings-CustomReportsTable-Btn-openEditCustomReportDialog"}
                                                        className="prevent-cell-click-wrapper"
                                                        onClick={() => this.setState({ openAddCustomReportDialog: true, editCustomReport: customReport })}
                                                    >
                                                        <i
                                                            className="fa fa-pencil"
                                                            style={{ float: "right", fontSize: 20, fontWeight: "bold" }}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </TableRowColumn>,
                                        <TableRowColumn key="delete" style={{ width: 10 }} className="prevent-cell-click">
                                            {this.state.hoverRowNumber === i &&
                                                <div onClick={e => e.stopPropagation()}>
                                                    <div data-intercom-target={i === 0 && "menu-AccountSettings-CustomReportsTable-Btn-DeleteItem"} onClick={() => this.handleDelete(customReport)} className="prevent-cell-click-wrapper">
                                                        <i
                                                            className="fa fa-trash-o"
                                                            style={{ float: "right", fontSize: 20, fontWeight: "bold" }}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </TableRowColumn>
                                    ]}
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                }
                {this.state.openAddCustomReportDialog &&
                    <AddCustomReportDialog
                        existingCustomReports={this.state.customReports}
                        editCustomReport={this.state.editCustomReport}
                        handleAdd={this.handleAdd}
                        handleUpdate={this.handleUpdate}
                        handleClose={() => this.setState({ openAddCustomReportDialog: false, editCustomReport: null })}
                    />
                }
            </div>
        )
    }
}

const styles = {
    tableBodyStyle: {
        backgroundColor: "none",
        borderBottom: "1px solid rgb(224,224,224)",
        borderTop: "1px solid rgb(224,224,224)"
    },
    columnValue: {
        textAlign: "left",
        cursor: "pointer",
        paddingLeft: 0
    }
}